import { clamp } from 'lodash';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { timestampSelector } from '../../navigation/selectors/navigation.selectors';
import { getExtent } from '../utils/scale';
import { useStrip } from './useStrip';

export const useRenderedChunk = () => {
  const { xScale } = useStrip();
  const duration = getExtent(xScale.domain());
  const ecgDuration = useSelector(roundedDurationSelector);
  const timestamp = useSelector(timestampSelector);

  /*
   We split the rendered area into chunks and render only the relevant part
   ----------------------------------------------------------------------------
                     |       ||            ||                 |
                     |       ||            ||                 |
                     |       ||            ||                 |
                     |       ||            ||                 |
                     |       ||            ||                 |
   ----------------------------------------------------------------------------
           /|\          /|\         /|\             /|\               /|\
            |            |           |               |                 |
       not rendered   rendered       |            rendered        not rendered
                                  visible
  */
  const chunkCount = Math.ceil(ecgDuration / duration);

  const visibleChunkIndex = Math.floor(timestamp / duration);
  const clampedIndex = clamp(visibleChunkIndex, 0, chunkCount - 1);

  const start = clamp(clampedIndex - 1, 0, chunkCount - 1) * duration;

  const end = start + 3 * duration;

  return {
    start,
    end,
  };
};
